// ============================================================
// BcStatesTable.js — every organisation's Business Central billing state
// (trial, converted waiting for the mandate, billing on, billing off), for
// the Platform Billing page. A2Z admins only.
// ============================================================
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getBcStates, STATE_LABELS } from '../api/bcBilling';
import StatusMessage from './StatusMessage';

export default function BcStatesTable() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    let live = true;
    getBcStates().then((d) => { if (live) setData(d); }).catch((e) => { if (live) setError((e && (e.detail || e.message)) || 'Could not load billing states.'); });
    return () => { live = false; };
  }, []);

  if (error) return <StatusMessage variant="error">{error}</StatusMessage>;
  if (!data) return <StatusMessage variant="loading">Loading billing states…</StatusMessage>;
  const integ = data.integration || {};
  return (
    <div className="cbill__card">
      <h3 className="cbill__title">Business Central billing by organisation</h3>
      <p className="cbill__hint">Business Central billing is {integ.enabled ? `switched on (${integ.mode})` : 'switched off'}{integ.enabled && !integ.configOk ? ', but its settings disagree, so it is not running' : ''}.</p>
      <div className="bcb__scroll">
        <table className="cbill__table">
          <thead><tr><th>Organisation</th><th>Lifecycle</th><th>Billing</th><th>BC customer</th><th>Mandate signed</th><th>First month</th><th className="cbill__num">Failed, unpaid</th></tr></thead>
          <tbody>{data.clients.map((c) => (
            <tr key={c.ClientID}>
              <td><Link to={`/clients/${c.ClientID}?tab=billing`}>{c.ClientName}</Link>{c.IsDemo ? ' (demo)' : ''}</td>
              <td>{c.LifecycleStatus}</td>
              <td>{c.BillingState ? STATE_LABELS[c.BillingState] || c.BillingState : <span className="cbill__muted">No billing settings</span>}</td>
              <td>{c.BcCustomerNumber || ''}</td>
              <td>{c.MandateSignedAt ? new Date(c.MandateSignedAt).toLocaleDateString('en-GB', { timeZone: 'Europe/London' }) : ''}</td>
              <td>{c.BillingStartPeriod || ''}</td>
              <td className="cbill__num">{c.UnpaidFailed > 0 ? <span className="cbill__warn">{c.UnpaidFailed}</span> : ''}</td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
}
